import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import type { InviteUserToOrganizationRequest } from '../../api/queries';
import { USER_ONBOARDING_KEY } from '../queries/onboarding/useUserOnboarding';

enum CacheKey {
  OrganizationUsers = 'OrganizationUsers',
}

export const useInviteUserToOrganizationMutation = () => {
  const { inviteUserToOrganization } = useServicesContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: InviteUserToOrganizationRequest) =>
      inviteUserToOrganization(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CacheKey.OrganizationUsers],
      });
      // An invited safety representative ticks off the step in «Kom i gang»
      queryClient.invalidateQueries({ queryKey: USER_ONBOARDING_KEY });
    },
  });
};